import { render, staticRenderFns } from "./JigsListing.vue?vue&type=template&id=461705fc"
import script from "./JigsListing.vue?vue&type=script&lang=ts"
export * from "./JigsListing.vue?vue&type=script&lang=ts"
import style0 from "./JigsListing.vue?vue&type=style&index=0&id=461705fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports